import { PageHeader } from '@/shared/components';
import { useTranslation } from 'react-i18next';
import { QuarantinedRevisionsCard } from './QuarantinedRevisionsCard';

/**
 * „Nicht zugeordnet“ (Board „Buchungen · Nicht zugeordnet“): Kanalbuchungen, die angekommen sind,
 * aber noch keinem Apartment zugeordnet werden konnten. Der Weg zurück steht im Pfad des Kopfs.
 * Verwaltung und Mitarbeiter, nicht Kunde und Reinigung.
 */
export function BookingQuarantinePage() {
  const { t } = useTranslation('revisionHolds');
  return (
    <>
      <PageHeader title="Nicht zugeordnet" description={t('description')} />
      <QuarantinedRevisionsCard />
    </>
  );
}
